import React, { useContext, useEffect } from 'react'
import { dataContext, localestr, toText } from '../utils.js'
import EditCtrl from '../cmp/EditCtrl.js';
import Panel from '../cmp/Panel'

function CatDevices4Edit({ data, actions }) {
    let wndData = ''
    if (data) wndData = data.wndData
    else wndData = actions.getWndData()
    const setWndData = actions.setWndData
    const tabClose = actions.tabClose

    const context = useContext(dataContext)
    const saveData = context.saveData
    const catDevices = context.data.catDevices
    const catDepartments = context.data.catDepartments
    const msg = context.msg
    const msg_arr = context.msg_arr
    const loadfrm = context.loadfrm
    const loaddata = context.loaddata

    const setValue = (name, data) => {
        if (name === 'Printer') if (data && parseInt(data.device) > 3) { msg(localestr('Невірний тип пристрою'), localestr('Помилка'), [{ caption: 'OK', action: () => {} }]); return }
        if (name === 'Printer') if (data && data.device && parseInt(data.device.value) > 3) { msg(localestr('Невірний тип пристрою'), localestr('Помилка'), [{ caption: 'OK', action: () => {} }]); return }
        let newData = { ...wndData }
        if (name === 'name' || name === 'department' || name === 'excise_only') newData.changed = true
        else if (name === 'keyfile' || name === 'crtfile' || name === 'pass') newData.changedkey = true
        else if (name === 'licfile') { newData.changedlic = true; newData.loadlic = true; }
        else if (name !== 'loadkey' && name !== 'loadlic') newData.changedreg = true
        if (name === 'keyfile') newData.loadkey = true
        if (data === '') newData[name] = null
        else newData[name] = data
        if(name === 'closing_shift') newData['closing_shift']=data.substring(0,3) + '59'
        setWndData(newData)
    }

    const setMerch = (term, merch) => {
        let newData = { ...wndData, changedreg: true }
        if (!newData.terminals) newData.terminals = []
        newData.terminals = newData.terminals.map(t => t.id === term.id ? { ...t, merchant: merch } : t)
        setWndData(newData)
    }

    const readFromDFS = (d) => {
        if (d) {
            if (!d.data) return
            if (!d.data.TaxObjects) return
            let obj = []
            for (let i = 0; i < d.data.TaxObjects.length; i++) {
                if (d.data.TaxObjects[i].TransactionsRegistrars) {
                    for (let k = 0; k < d.data.TaxObjects[i].TransactionsRegistrars.length; k++) {
                        obj.push({
                            Tin: d.data.TaxObjects[i].Tin,
                            ShopName: d.data.TaxObjects[i].Name,
                            OrgName: d.data.TaxObjects[i].OrgName,
                            Address: d.data.TaxObjects[i].Address,
                            Ipn: d.data.TaxObjects[i].Ipn,
                            NumFiscal: d.data.TaxObjects[i].TransactionsRegistrars[k].NumFiscal,
                            NumLocal: d.data.TaxObjects[i].TransactionsRegistrars[k].NumLocal,
                            visualName: d.data.TaxObjects[i].TransactionsRegistrars[k].NumFiscal + ' ' + d.data.TaxObjects[i].Name + ' ' + d.data.TaxObjects[i].Address
                        })
                    }
                }
            }
            if (obj.length === 1) {
                let newData = { ...wndData, ...obj[0] }
                newData.changedreg = true
                setWndData(newData)
            } else {
                if (wndData.NumFiscal) {
                    const idx = obj.findIndex(el => String(el.NumFiscal) === String(wndData.NumFiscal))
                    if (idx !== -1) {
                        let newData = { ...wndData, ...obj[idx] }
                        newData.changedreg = true
                        setWndData(newData)
                        return
                    }
                }
                const arr_buttons = obj.map(el => {
                    return { caption: el.visualName, action: () => { setWndData({ ...wndData, ...el, changedreg: true }) } }
                })
                msg_arr(localestr('Виберіть торгову точку'), localestr('Вибір'), arr_buttons)
            }
        } else {
            if (!wndData.id) { msg(localestr('Спочатку треба зберегти елемент'), localestr('Помилка'), [{ caption: 'OK', action: () => {} }]); return }
            if (!wndData.keyfile) { msg(localestr('Спочатку треба завантажити ключ'), localestr('Помилка'), [{ caption: 'OK', action: () => {} }]); return }
            let dataJS = ''
            dataJS = JSON.stringify({ id: wndData.id, command: 'Objects' })
            loaddata("action=rroCommand&data=" + dataJS, undefined, readFromDFS)
        }
    }

    const update = (d) => {
        let newData = { ...wndData, ...d.data, changed: false, changedkey: false, changedlic: false, changedreg: false, loadkey: false, loadlic: false }
        setWndData(newData)
    }

    const saveValue = (action = () => {}) => {
        if (!wndData.changed && !wndData.changedkey && !wndData.changedlic && !wndData.changedreg) { action({}); return }
        let errmsg = ''
        const formData = new FormData()
        let wait = false
        let data = { type: '' + wndData.device }
        if (wndData.changed) {
            if (!wndData.name) errmsg = errmsg + ' ' + localestr("Не заповнено ім'я")
            data.name = (wndData.name || '').substring(0, 25)
            data.department = wndData.department && wndData.department.id ? { id: wndData.department.id } : { id: null }
            data.excise_only = wndData.excise_only || '0'
        }
        if (wndData.changedkey) {
            if (!wndData.keyfile) errmsg = errmsg + ' ' + localestr("Не вибрано файл ключа")
            else {
                formData.append('keyfile', wndData.keyfile)
                if (wndData.keyfile.name.substr(-3).toLowerCase() !== 'jks' && !wndData.crtfile) errmsg = errmsg + ' ' + localestr("Не вибрано файл сертифікату")
                else formData.append('crtfile', wndData.crtfile)
                wait = true
            }
            if (!wndData.pass) errmsg = errmsg + ' ' + localestr("Не вказано пароль")
            data.pass = wndData.pass || null
        }
        if (wndData.changedlic) {
            if (!wndData.licfile) errmsg = errmsg + ' ' + localestr("Не вибрано файл ліцензії")
            else formData.append('licfile', wndData.licfile)
        }
        if (wndData.changedreg) {
            if (!wndData.NumFiscal) errmsg = errmsg + ' ' + localestr("Не заповнено фіскальний №")
            if (wndData.conection && parseInt(wndData.conection)) {
                if (!wndData.ip) errmsg = errmsg + ' ' + localestr("Не заповнено IP адресу сервера")
                if (!wndData.port) errmsg = errmsg + ' ' + localestr("Не заповнено порт")
            }
            data.Cashier = wndData.Cashier || null
            data.Tin = wndData.Tin || null
            data.ShopName = wndData.ShopName || null
            data.OrgName = wndData.OrgName || null
            data.Address = wndData.Address || null
            data.Ipn = wndData.Ipn || null
            data.NumFiscal = wndData.NumFiscal || null
            data.NumLocal = wndData.NumLocal || null
            data.Printer_id = wndData.Printer ? wndData.Printer.id || null : null
            data.OflineSuport = wndData.OflineSuport || null
            data.doc_print = wndData.doc_print || null
            data.rep_print = wndData.rep_print || null
            data.oth_print = wndData.oth_print || null
            data.excise = wndData.excise || null
            data.vat = wndData.vat || null
            data.conection = wndData.conection || null
            data.ip = wndData.ip || null
            data.port = wndData.port || null
            data.terminals = wndData.terminals ? wndData.terminals.filter(it => it.id && it.merchant).map(it => ({ id: it.id, merchant: it.merchant })) : []
            data.closing_shift = wndData.closing_shift || null
        }
        if (typeof wndData.liqpay === 'object') data.liqpay = wndData.liqpay
        else if (!wndData.is_liqpay) data.liqpay = null
        if (typeof wndData.mono === 'object') data.mono = wndData.mono
        else if (!wndData.is_mono) data.mono = null
        if (wndData.id) data.id = wndData.id
        if (parseInt(wndData.device) !== 4) errmsg = errmsg + ' ' + (localestr("Недопустимий тип пристрою"))
        if (errmsg !== '') { msg(errmsg, localestr('Помилка'), [{ caption: 'OK', action: () => {} }]); return }
        let dataJS = ''
        if (data) dataJS = JSON.stringify(data)
        dataJS = dataJS.replace(new RegExp('\'', 'g'), '\'\'')
        formData.append('action', 'modDevices');
        formData.append('data', dataJS);
        if (wait) msg(localestr('Конвертація ключа може зайняти тривалий час \n будь ласка дочекайдесь закінчення операції'), localestr('Інформація'), [{ caption: 'OK', action: () => { loadfrm(formData, newData => saveData(newData, action)) } }])
        else loadfrm(formData, newData => saveData(newData, action))
    }

    const saveToTest = () => {
        let errmsg = ''
        const formData = new FormData()
        let wait = false
        let data = { type: '5' }
        if (wndData.changed) {
            if (!wndData.name) errmsg = errmsg + ' ' + localestr("Не заповнено ім'я")
            data.name = (wndData.name || '').substring(0, 25)
            data.department = wndData.department && wndData.department.id ? { id: wndData.department.id } : { id: null }
            data.excise_only = wndData.excise_only || '0'
        }
        if (wndData.changedkey) {
            if (!wndData.keyfile) errmsg = errmsg + ' ' + localestr("Не вибрано файл ключа")
            else {
                formData.append('keyfile', wndData.keyfile)
                if (wndData.keyfile.name.substr(-3).toLowerCase() !== 'jks' && !wndData.crtfile) errmsg = errmsg + ' ' + localestr("Не вибрано файл сертифікату")
                else formData.append('crtfile', wndData.crtfile)
                wait = true
            }
            if (!wndData.pass) errmsg = errmsg + ' ' + localestr("Не вказано пароль")
            data.pass = wndData.pass || null
        }
        if (wndData.changedlic) {
            if (!wndData.licfile) errmsg = errmsg + ' ' + localestr("Не вибрано файл ліцензії")
            else formData.append('licfile', wndData.licfile)
        }
        if (wndData.changedreg) {
            if (!wndData.NumFiscal) errmsg = errmsg + ' ' + localestr("Не заповнено фіскальний №")
            data.Cashier = wndData.Cashier || null
            data.Tin = wndData.Tin || null
            data.ShopName = wndData.ShopName || null
            data.OrgName = wndData.OrgName || null
            data.Address = wndData.Address || null
            data.Ipn = wndData.Ipn || null
            data.NumFiscal = wndData.NumFiscal || null
            data.NumLocal = wndData.NumLocal || null
            data.Printer_id = wndData.Printer ? wndData.Printer.id || null : null
            data.OflineSuport = wndData.OflineSuport || null
            data.doc_print = wndData.doc_print || null
            data.rep_print = wndData.rep_print || null
            data.oth_print = wndData.oth_print || null
            data.excise = wndData.excise || null
            data.vat = wndData.vat || null
            data.conection = wndData.conection || null
            data.ip = wndData.ip || null
            data.port = wndData.port || null
            data.terminalGroups = wndData.terminalGroups ? wndData.terminalGroups.map(group => ({
                id: group.id,
                merch: group.merch || null,
                deviceNum: group.deviceNum || null
            })) : null
            data.closing_shift = wndData.closing_shift || null
        }
        if (wndData.id) data.id = wndData.id
        if (parseInt(wndData.device) !== 4) errmsg = errmsg + ' ' + (localestr("Недопустимий тип пристрою"))
        if (errmsg !== '') { msg(errmsg, localestr('Помилка'), [{ caption: 'OK', action: () => {} }]); return }
        let dataJS = ''
        if (data) dataJS = JSON.stringify(data)
        dataJS = dataJS.replace(new RegExp('\'', 'g'), '\'\'')
        formData.append('action', 'modDevices');
        formData.append('data', dataJS);
        if (wait) msg(localestr('Конвертація ключа може зайняти тривалий час \n будь ласка дочекайдесь закінчення операції'), localestr('Інформація'), [{ caption: 'OK', action: () => { loadfrm(formData, newData => saveData(newData, tabClose)) } }])
        else loadfrm(formData, newData => saveData(newData, tabClose))
    }

    function setValueObj(name, key, data) {
        let newData = { ...wndData, changed: true }
        if (!newData[name]) newData[name] = {}
        if (data === '') newData[name][key] = null
        else newData[name][key] = data
        setWndData(newData)
    }

    let cont1 = null
    if (wndData.loadkey || !wndData.keyfile) {
        let cert = <EditCtrl Capt={localestr('Сертифікат')} Value={wndData.certfile} typeVal={'crtfile'} setVal={(d) => { setValue('crtfile', d) }} width1='85' width2='252' />
        if (wndData.keyfile && wndData.keyfile.name) if (wndData.keyfile.name.substr(-3).toLowerCase() === 'jks') cert = null
        cont1 = <>
            <EditCtrl Capt={localestr('Ключ')} Value={wndData.keyfile} typeVal={'keyfile'} setVal={(d) => { setValue('keyfile', d) }} width1='85' width2='252' />
            {cert}
            <EditCtrl Capt={localestr('Пароль')} Value={wndData.pass} typeVal={'pass'} setVal={(d) => { setValue('pass', d) }} width1='82' width2='100' />
        </>
    } else {
        cont1 = <div style={{ margin: '2px 0', display: 'inherit' }}>
            <EditCtrl Capt={localestr('Ключ')} Value={localestr('Дійсний до ') + toText(wndData.keyfile)} typeVal={'text'} setVal={(d) => {}} width1='85' width2='146' disabled={true} />
            <div style={{ width: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
            <div style={{ width: '90px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => { setValue('loadkey', true) }}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>{localestr('Змінити')}</div></div>
        </div>
    }

    let cont2 = null
    if (wndData.loadlic || !wndData.licfile) {
        cont2 = <EditCtrl Capt={localestr('Файл ліцензії')} Value={wndData.licfile} typeVal={'licfile'} setVal={(d) => { setValue('licfile', d) }} width1='85' width2='252' />
    } else {
        cont2 = <div style={{ margin: '2px 0', display: 'inherit' }}>
            <EditCtrl Capt={localestr('Ліцензія')} Value={wndData.licfile.length < 11 ? localestr('Дійсна до ') + toText(wndData.licfile + 'T23:59:59') : toText(wndData.licfile)} typeVal={'text'} setVal={(d) => {}} width1='85' width2='146' disabled={true} />
            <div style={{ width: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
            <div style={{ width: '90px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => { setValue('loadlic', true) }}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>{localestr('Змінити')}</div></div>
        </div>
    }

    let liqpay = null
    if (!wndData.is_liqpay) {
        liqpay = <>
            <EditCtrl Capt={localestr('Public Key')} Value={(wndData.liqpay || {}).public_key} typeVal={'text'} setVal={(d) => { setValueObj('liqpay', 'public_key', d) }} width1='80' width2='257' />
            <EditCtrl Capt={localestr('Private Key')} Value={(wndData.liqpay || {}).privat_key} typeVal={'text'} setVal={(d) => { setValueObj('liqpay', 'privat_key', d) }} width1='80' width2='257' />
        </>
    } else {
        liqpay = <div>
            <div style={{ width: '200px', display: 'inline-block', verticalAlign: 'bottom', float: 'right' }} className={'key_btn'} onClick={() => { setValue('is_liqpay', null) }}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>{localestr('Змінити налаштування')}</div></div>
            <span style={{ fontSize: 'small', fontStyle: 'italic', color: 'blue' }}>
                {localestr('LiqPay налаштовано. Дані використовуються як основний засіб оплати для поточного ПРРО.')}
            </span></div>
    }

    let monobank = null
    if (!wndData.is_mono || typeof wndData.mono === 'object') {
        monobank = <>
            <EditCtrl Capt={localestr('Public Key')} Value={(wndData.mono || {}).public_key} typeVal={'text'} setVal={(d) => { setValueObj('mono', 'public_key', d) }} width1='80' width2='257' />
            <EditCtrl Capt={localestr('Private Key')} Value={(wndData.mono || {}).privat_key} typeVal={'text'} setVal={(d) => { setValueObj('mono', 'privat_key', d) }} width1='80' width2='257' />
        </>
    } else {
        monobank = <div>
            <div style={{ width: '200px', display: 'inline-block', verticalAlign: 'bottom', float: 'right' }} className={'key_btn'} onClick={() => { setValue('is_mono', null) }}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>{localestr('Змінити налаштування')}</div></div>
            <span style={{ fontSize: 'small', fontStyle: 'italic', color: 'blue' }}>
                {localestr('MonoBank налаштовано. Дані використовуються як основний засіб оплати для поточного ПРРО.')}
            </span></div>
    }

    let terminal = (wndData.terminals || []).map(term => {return(
        <div key={term.id} style={{ margin: '2px 0', display: 'inherit' }}>
            <div style={{ width: '65px', display: 'inline-block',lineHeight: '28px', flexGrow: 4, maxWidth: '70px' }}>{localestr('термінал')}</div>
            <div style={{ width: '65px', display: 'inline-block',lineHeight: '28px', flexGrow: 4, maxWidth: '120px', color: 'blue',fontWeight: 'bold' }}>{term.name}</div>
            <EditCtrl Capt={localestr('№ мерчанта')} Value={term.merchant||''} typeVal={'text'} setVal={(d) => { setMerch(term, d) }} width1='107' width2='40' />
        </div> 
    )})

    useEffect(() => {
        let newData = { ...wndData }
        let upd = false
        let need_save = false
        if (wndData.Printer && !wndData.Printer.name) {
            if (catDevices) {
                const el = catDevices.find(it => it.id === wndData.Printer.id)
                if (el) newData = { ...newData, Printer: el }
                upd = true
            }
        }
        if (wndData.department && !wndData.department.name) {
            if (catDepartments) {
                const el = catDepartments.find(it => it.id === wndData.department.id)
                if (el) newData = { ...newData, department: el }
                upd = true
            }
        }
        const cat_terminals = catDevices.filter(it => it.device === '7' && it.marked==='0')
        const terminals = wndData.terminals || []
        for (let i = 0; i < terminals.length; i++) {
            const el = cat_terminals.find(it => it.id === terminals[i].id)
            if (el) {
                if(!terminals[i].name) {
                    terminals[i].name = el.name
                    upd = true
                }
                el.del=true
            } else {
                terminals[i].id = null
                upd = true
                need_save = true
            }
        }
        for (let i = 0; i < cat_terminals.length; i++) {
            if (!cat_terminals[i].del) {
                terminals.push(cat_terminals[i])
                upd = true
                need_save = true
            }
        }
        newData.terminals = terminals.filter(it => it.id)
        if(need_save) newData.changedreg = true
        if (upd) setWndData(newData)
    // eslint-disable-next-line 
    }, [catDevices, catDepartments])

    return (
        <div style={{ display: 'flex', flexDirection: 'column', margin: '4px 0', alignSelf: 'flex-start', flexGrow: '10000' }}>
            <div style={{ margin: '2px 0', display: 'inherit' }}>
                <EditCtrl Capt={'Id'} Value={wndData.id} typeVal={'text'} setVal={(d) => { setValue('id', d) }} width1='43' width2='50' disabled={true} />
                <div style={{ width: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
                <EditCtrl Capt={localestr('Назва')} Value={wndData.name} typeVal={'text'} setVal={(d) => { setValue('name', d) }} width1='50' width2='186' />
            </div>
            {cont1}
            {cont2}
            <EditCtrl Capt={localestr('Касир')} Value={wndData.Cashier} typeVal={'text'} setVal={(d) => { setValue('Cashier', d) }} width1='155' width2='182' />
            <EditCtrl Capt={localestr('Код ЄДРПОУ')} Value={wndData.Tin} typeVal={'text'} setVal={(d) => { setValue('Tin', d) }} width1='155' width2='182' />
            <EditCtrl Capt={localestr('Торгова точка')} Value={wndData.ShopName} typeVal={'text'} setVal={(d) => { setValue('ShopName', d) }} width1='155' width2='182' />
            <EditCtrl Capt={localestr('Організація')} Value={wndData.OrgName} typeVal={'text'} setVal={(d) => { setValue('OrgName', d) }} width1='155' width2='182' />
            <EditCtrl Capt={localestr('Адреса')} Value={wndData.Address} typeVal={'text'} setVal={(d) => { setValue('Address', d) }} width1='155' width2='182' />
            <EditCtrl Capt={localestr('ІПН (ПДВ)')} Value={wndData.Ipn} typeVal={'text'} setVal={(d) => { setValue('Ipn', d) }} width1='155' width2='182' />
            <EditCtrl Capt={localestr('Фіскальний № РРО')} Value={wndData.NumFiscal} typeVal={'text'} setVal={(d) => { setValue('NumFiscal', d) }} width1='155' width2='182' />
            <EditCtrl Capt={localestr('Локальний № РРО')} Value={wndData.NumLocal} typeVal={'text'} setVal={(d) => { setValue('NumLocal', d) }} width1='155' width2='182' />
            <EditCtrl Capt={localestr('Чековий принтер')} Value={wndData.Printer} typeVal={'catDevices'} setVal={(d) => { setValue('Printer', d) }} width1='155' width2='182' />
            <EditCtrl Capt={localestr('Фіскальний підрозділ')} Value={wndData.department} typeVal={'catDepartments'} setVal={(d) => { setValue('department', d) }} width1='165' width2='172' />
            <EditCtrl Capt={localestr('Використовувати цей підрозділ тільки для акцизних товарів')} Value={wndData.excise_only} typeVal={'check'} setVal={(d) => { setValue('excise_only', d) }} width1='446' width2='13' />
            <EditCtrl Capt={localestr('Автоматичне закриття зміни')} Value={wndData.closing_shift} typeVal={'time'} setVal={(d) => { setValue('closing_shift', d) }} width1='185' width2='152' />
            <div style={{ margin: '2px 0', display: 'inherit' }}>
                <EditCtrl Capt={localestr('Платник акцизного податку')} Value={wndData.excise} typeVal={'check'} setVal={(d) => { setValue('excise', d) }} width1='202' width2='13' />
                <div style={{ width: '8px', display: 'inline-block', flexGrow: 8, maxWidth: '16px' }}></div>
                <EditCtrl Capt={localestr('Платник ПДВ')} Value={wndData.vat} typeVal={'check'} setVal={(d) => { setValue('vat', d) }} width1='101' width2='13' />
            </div>
            <div style={{ margin: '2px 0', display: 'inherit' }}>
                <div style={{ minWidth: '80px', display: 'inline-block', flexGrow: 80, maxWidth: '160px', lineHeight: '24px', margin: '2px 0' }}>{localestr('Друкувати')}</div>
                <EditCtrl Capt={localestr('чеки')} Value={wndData.doc_print} typeVal={'l_check'} setVal={(d) => { setValue('doc_print', d) }} width1='39' width2='13' />
                <div style={{ width: '11px', display: 'inline-block', flexGrow: 11, maxWidth: '22px' }}></div>
                <EditCtrl Capt={localestr('звіти')} Value={wndData.rep_print} typeVal={'l_check'} setVal={(d) => { setValue('rep_print', d) }} width1='41' width2='13' />
                <div style={{ width: '11px', display: 'inline-block', flexGrow: 11, maxWidth: '22px' }}></div>
                <EditCtrl Capt={localestr('службові чеки')} Value={wndData.oth_print} typeVal={'l_check'} setVal={(d) => { setValue('oth_print', d) }} width1='116' width2='13' />
            </div>
            <Panel caption={localestr('Підключення банківського терміналу')} width={337} open={wndData.p_term === undefined ? false : wndData.p_term} setOpen={d => setWndData({ ...wndData, p_term: d })}>
                {terminal}
            </Panel>
            <Panel caption={localestr('Налаштування liqpay')} width={340} open={wndData.p_liq === undefined ? false : wndData.p_liq} setOpen={d => setWndData({ ...wndData, p_liq: d })}>
                {liqpay}
            </Panel>
            <Panel caption={localestr('Налаштування monobank')} width={340} open={wndData.p_mono === undefined ? false : wndData.p_mono} setOpen={d => setWndData({ ...wndData, p_mono: d })}>
                {monobank}
            </Panel>
            <div style={{ margin: '2px 0', display: 'inherit', flexWrap: 'wrap' }}>
                <div style={{ width: '60px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => { saveValue(tabClose) }}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>OK</div></div>
                <div style={{ width: '90px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => { saveValue(update) }}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>{localestr('Зберегти')}</div></div>
                <div style={{ width: '150px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => { readFromDFS() }}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>{localestr('Зчитати з сервера ДФС')}</div></div>
                <div style={{ width: '160px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => { saveToTest() }}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>{localestr('В тестовий режим')}</div></div>
            </div>
        </div>
    )
}

export default CatDevices4Edit